<template>
  <BaseFormLayout
    :title="
      editMode
        ? `Edit ${configurationModule.integrationPartner}`
        : `Add ${configurationModule.integrationPartner}`
    "
    :nonFieldErrors="formErrors?.non_field_errors"
    :isHeader="isHeader"
  >
    <template #actions>
      <SecondaryButton
        id="integrationPartnerReset"
        color="secondary"
        depressed
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
        Reset
      </SecondaryButton>
      <PrimaryButton
        id="warehouseSubmit"
        btnClass="text-uppercase rounded-lg"
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="integrationPartnerForm"
        class="h-100"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row no-gutters class="h-100 ma-0">
          <v-col cols="12">
            <v-card
              elevation="0"
              class="pa-4 h-100 mr-lg-4 rounded-lg overflow-y-auto"
              style="height: calc(100vh - 253px)"
            >
              <v-row class="ma-0">
                <v-col cols="12">
                  <span class="text-subtitle-1 font-weight-bold"
                    >{{
                      configurationModule.integrationPartner
                    }}
                    Information</span
                  >
                </v-col>

                <v-col cols="3">
                  <InputField
                    id="name"
                    v-model="integrationPartnerDetails.name"
                    label="Integration Partner Name"
                    :required="true"
                    name="name"
                    :error-messages="formErrors.name"
                    @input="delete formErrors.name"
                  />
                </v-col>

                <v-col cols="3">
                  <InputField
                    id="url"
                    v-model="integrationPartnerDetails.url"
                    :label="`${configurationModule.integrationPartner} Url`"
                    name="url"
                    required
                    :error-messages="formErrors.url"
                    @input="delete formErrors.url"
                  />
                </v-col>
                <v-col cols="3">
                  <SelectField
                    id="event"
                    v-model="integrationPartnerDetails.event"
                    label="Event*"
                    name="Event"
                    :disabled="editMode"
                    item-text="name"
                    item-value="value"
                    :items-list="[
                      {
                        name: 'Order Completion',
                        value: 'order_completion',
                      },
                      {
                        name: 'Trip Completion',
                        value: 'trip_completion',
                      },
                    ]"
                    :rules="[(val) => !!val || `Event is required`]"
                    :error-messages="formErrors.event"
                    @input="delete formErrors.event"
                  />
                </v-col>
                <v-col cols="3">
                  <SelectField
                    id="event"
                    v-model="integrationPartnerDetails.object_type"
                    label="Object Type*"
                    name="Object Type"
                    item-text="name"
                    item-value="value"
                    :items-list="[
                      {
                        name: 'List',
                        value: 'list',
                      },
                      {
                        name: 'Object',
                        value: 'object',
                      },
                    ]"
                    :rules="[(val) => !!val || `Obejct Type is required`]"
                    :error-messages="formErrors.object_type"
                    @input="delete formErrors.object_type"
                  />
                </v-col>
                <v-col cols="6">
                  <TextAreaField
                    id="header"
                    v-model="integrationPartnerDetails.header"
                    :label="`Header`"
                    name="url"
                    required
                    :error-messages="formErrors.header"
                    @input="delete formErrors.header"
                  />
                </v-col>
                <v-col cols="6">
                  <TextAreaField
                    id="schema"
                    v-model="integrationPartnerDetails.output_schema"
                    :label="`Output Schema`"
                    name="Shcema"
                    required
                    :error-messages="formErrors.output_schema"
                    @input="delete formErrors.output_schema"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseFormLayout>
</template>
  
  <script>
import { bus } from "@/main.js";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { configurationModule } from "@/utils/moduleMapping";
import JsonViewer from "vue-json-viewer";

export default {
  components: {
    BaseFormLayout,
    JsonViewer,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      required: true,
    },
    isHeader: {
      type: Boolean,
      default: true,
    },
    isBranchDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configurationModule,
      fileInput: null,
      formCount: 0,
      isValid: true,
      integrationPartnerDetails: {},
      userDetails: this.$helper.getUserDetailsLocalStorage(),
      formErrors: {},
    };
  },
  computed: {},
  methods: {
    onError() {
      console.log("error");
    },
    resetForm() {
      this.$refs.integrationPartnerForm.reset();
      if ("companyId" in this.$route.query) {
        this.integrationPartnerDetails.company = this.$route.query.companyId;
      }
    },
    getIntegrationPartnerObject(id) {
      this.$api.integrationPartner
        .getIntegrationPartnerObject(id)
        .then((res) => {
          this.integrationPartnerDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      if (!this.$refs.integrationPartnerForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }

      let data = { ...this.integrationPartnerDetails };
      console.log("data ==>", data);
      if (this.editMode) {
        delete data.company;
        delete data.event;
        this.$api.integrationPartner
          .updateIntegrationPartnerObject({
            id: this.integrationPartnerDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Integration partner information updated!",
              color: "success",
            });
            this.resetForm();
            this.$router.push({ name: "integration-partner-list" });
          })
          .catch((err) => {
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      } else {
        console.log(data);
        data.header = JSON.parse(data.header);
        data.output_schema = JSON.parse(data.output_schema);
        this.$api.integrationPartner
          .createIntegrationPartnerObject(data)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Integration Partner created!",
              color: "success",
            });
            this.resetForm();
            if (!this.isHeader) {
              this.$emit("redirect", true);
            } else {
              this.$router.push({ name: "integration-partner-list" });
            }
          })
          .catch((err) => {
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      }
    },
  },
  mounted() {
    if ("companyId" in this.$route.query) {
      this.integrationPartnerDetails.company = this.$route.query.companyId;
    }
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.getIntegrationPartnerObject(this.$route.params.id);
    }
    let inter = setInterval(() => {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (!this.editMode && obj.preferred_branch && obj.preferred_branch.id) {
        clearInterval(inter);
        this.integrationPartnerDetails = {
          branch: obj.preferred_branch.id,
        };
      }
      if (!this.editMode) {
        this.integrationPartnerDetails = {
          company: obj.company,
        };
      }
    }, 200);
  },
};
</script>
  
  <style>
.v-select__slot label {
  z-index: 2;
}
</style>
  